<div class="vl-overlay" *ngIf="state.phase !== 'idle'" (click)="onOverlayClick($event)">
  <div class="vl-card" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">

    <!-- fetching -->
    <ng-container *ngIf="state.phase === 'fetching'">
      <div class="vl-icon vl-icon--spin">
        <i class="fas fa-circle-notch fa-spin"></i>
      </div>
      <h2 class="vl-title">Preparing VM session…</h2>
      <p class="vl-body">Retrieving your connection details from the server.</p>
    </ng-container>

    <!-- conflict -->
    <ng-container *ngIf="state.phase === 'conflict'">
      <div class="vl-icon vl-icon--warning">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <h2 class="vl-title">Session already active</h2>
      <p class="vl-body">
        You already have an active VM session
        <span *ngIf="state.conflictContext"> ({{ state.conflictContext }})</span>.
        Close the existing session before starting a new one.
      </p>
      <div class="vl-actions">
        <button class="vl-btn vl-btn--secondary" (click)="dismiss()">Close</button>
      </div>
    </ng-container>

  </div>
</div>
